import ProjectStatusDatatable from "@/components/Projects/ProjectStatusDatatable.vue";


export default [{
    path: 'project',
    alias: 'projects',
    name: 'Projects',
    redirect: "/project/status",
    meta: {
        requiresAuth: true
    },
    children: [
        {
            path: "status",
            name: "Project Status",
            components: {
                page: ProjectStatusDatatable
            }
        }
    ]
}];